module.exports = __webpack_public_path__ + "img/laswerk4.38d1a280.jpg";